module.exports = __webpack_public_path__ + "img/back vent length.7744a111.png";